module.exports = "\r\n.row:nth-child(odd){\r\n    background: #ececec;\r\n    padding-top: 10px;\r\n  } \r\n  .row:nth-child(even){     \r\n    padding-top: 10px;\r\n  }  "


//////////////////
// WEBPACK FOOTER
// ./src/app/fund-management/fund-management.component.css
// module id = ./src/app/fund-management/fund-management.component.css
// module chunks = main